<template>
<div class="drawerWrap">
  <div class="drawerBody">
    <el-form ref="form" :model="form" :rules="formRules" label-position="right" label-width="120px">
      <el-form-item label="区域名称" prop="name">
        <el-input v-model="form.name" maxlength="20" placeholder="请输入区域名称"></el-input>
      </el-form-item>
      <el-form-item label="区域类别" prop="type">
        <el-select v-model="form.type" placeholder="请选择区域类别">
          <el-option v-for="item in zonetypeoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="建筑结构" prop="buildingStructure">
        <el-select v-model="form.buildingStructureVal" placeholder="请选择建筑结构" @change="changeBuild">
          <el-option v-for="item in buildingoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="消防电梯" prop="fireElevator">
        <el-input v-model="form.fireElevator"  maxlength="20" placeholder="请输入消防电梯"></el-input><span class="sp">&nbsp;&nbsp;&nbsp;部</span>
      </el-form-item>
      <el-form-item label="火灾危险性" prop="danger">
        <el-select v-model="form.dangerVal" placeholder="请选择火灾危险性"  @change="changeDanger">
          <el-option v-for="item in dangeroptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="耐火等级" prop="fireRating">
        <el-select v-model="form.fireRatingVal" placeholder="请选择耐火等级" @change="changeRating">
          <el-option v-for="item in fireratingoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="火种情况" prop="fire">
        <el-radio v-model="form.fire" label="1">有明火</el-radio>
        <el-radio v-model="form.fire" label="2">无明火</el-radio>
      </el-form-item>
      <el-form-item label="消防重点部位" prop="isKeyAreas">
        <el-checkbox v-model="checked">是</el-checkbox>
      </el-form-item>
      <el-form-item label="负责人员" prop="person">
        <el-select v-model="form.person" placeholder="请选择负责人员">
          <el-option v-for="item in personoptions" :key="item.id" :label="item.username" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域底图" prop="img">
        <el-upload :class="{'demo-httpRequestImg':httpRequestImg}" action :limit="1" list-type="picture-card" :http-request="selectPicUpload" :before-upload="beforeAvatarUpload" :on-preview="handlePictureCardPreview" :file-list="fileList" :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </el-form-item>
    </el-form>
  </div>
  <div class="drawerFoot">
    <el-button type="primary" @click="confirmHandle()" :loading="loading">{{ loading ? '提交中' : '提交' }}</el-button>
    <el-button @click="cancelHandle()">取 消</el-button>
  </div>
</div>
</template>

<script>
export default {
  props: {
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    handleType: {
      type: String,
      default: ""
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
       httpRequestImg:false,//展示单个图片
      dialogVisible: false,
      dialogImageUrl: "",
      checked: true,
      radio: "1",
      show: "添加",
      personoptions: [],
      zonetypeoptions: [],
      buildingoptions: [],
      dangeroptions: [],
      fireratingoptions: [],
      buildingStructure:"",
      danger: "",
      fireRating:"",
      orgList: [],
      roleList: [],
      form: {
        name: "",
        fireElevator: ""
      },
      fileList: [],
      imgData: null,
      formRules: {
        name: [{
          required: true,
          validator: this.validateName,
          trigger: "blur"
        }],
        fireElevator: [{
          required: true,
          validator: this.validateFireElevator,
          trigger: "blur"
        }]
      }
    };
  },
  created() {
    console.log(this.handleType);
    console.log(this.editData);
    this.searchdict("zone_type", 1);
    this.searchdict("building_type", 2);
    this.searchdict("danger_type", 3);
    this.searchdict("rating_type", 4);
    this.request
      .get("/user/queryAll")
      .then(res => {
         console.log(res);
        if (res.code == 200) {
          this.personoptions = res.data;
        } else if(res.code==500){
          this.personoptions = []
          //    this.msg.warn(res.msg);
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  mounted() {
    this.init();
  },
  methods: {
    changeBuild(value){
      let obj = {};
      obj = this.buildingoptions.find((item)=>{//这里的userList就是上面遍历的数据源
        return item.value=== value;//筛选出匹配数据
      });
      this.buildingStructure=obj.label;
    },
     changeDanger(value){
      //  debugger;
      let obj = {};
      obj = this.dangeroptions.find((item)=>{//这里的userList就是上面遍历的数据源
        return item.value=== value;//筛选出匹配数据
      });
       this.danger=obj.label;
    },
      changeRating(value){
      let obj = {};
      obj = this.fireratingoptions.find((item)=>{//这里的userList就是上面遍历的数据源
        return item.value=== value;//筛选出匹配数据
      });
       this.fireRating=obj.label;
    },

    searchdict(stype, domid) {
      this.request
        .get("/Dictionary/query?type=" + stype)
        .then(res => {
          console.log(res);
          if (res.code == 200) {
            switch (domid) {
              case 1:
                this.zonetypeoptions = res.data;
                break;
              case 2:
                this.buildingoptions = res.data;
                break;
              case 3:
                this.dangeroptions = res.data;
                break;
              case 4:
                this.fireratingoptions = res.data;
                break;
            }
          } else {
            switch (domid) {
              case 1:
                this.zonetypeoptions = [];
                break;
              case 2:
                this.buildingoptions = [];
                break;
              case 3:
                this.dangeroptions = [];
                break;
              case 4:
                this.fireratingoptions = [];
                break;
            }
            // this.msg.warn(res.msg);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    init() {
      if (this.handleType == "add") {
        this.form = {
          name: '',
          fireElevator: ''
        };
      } else if (this.handleType == "edit") {
        if (this.editData.id) {
          this.form = {
            ...this.editData
          };
           this.buildingStructure=this.form.buildingStructure;
           this.danger=this.form.danger;
           this.fireRating=this.form.fireRating;
          this.form.add_time = null;
          this.form.type = this.editData.type.toString();
          if(this.editData.personid==0){
             this.form.person = null
          }else{
            this.form.person = this.editData.personid;             
          }
          if (this.editData.image) {
            this.httpRequestImg=true
            let obj = new Object();
            obj.url = this.editData.image;
            this.fileList.push(obj);
            console.log(this.fileList);
          }else{
            this.httpRequestImg=false
          }
        }
      }
    },
    cancelHandle() {
      //取消
      this.$emit("cancel", false);
    },
    confirmHandle() {
      this.$refs["form"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        this.$emit("update:loading", true);
        //确认
        var formData = new FormData();
        formData.append("files", this.imgData);
  
           this.form.buildingStructure=this.buildingStructure;
           this.form.danger=this.danger;
           this.form.fireRating=this.fireRating;
  
    
        this.request
          .postParamsForm("/Zone/zonesave", this.form, formData)
          .then(res => {
            console.log(res);
            if (res.code == 200) {
              this.$emit("confirm", res.code);
              if (this.handleType == "add") {
                  this.msg.success("添加成功！")                  
              }else if(this.handleType=="edit"){
                  this.msg.success("修改成功！")                 
              }
            } else if(res.code==500){
              this.msg.warn(res.msg);
            }
            this.$emit("update:loading", false)
          })
          .catch(error => {
            console.log(error);
            this.$emit("update:loading", false)

          });
      })
    },
    //上传图标事件
    selectPicUpload(obj) {
      console.log(obj);
      this.imgData = obj.file;
      this.httpRequestImg=true      
    },
    //对上传图片的大小、格式进行限制
    beforeAvatarUpload(file) {
      const isSVG = file.type === "image/svg";
      const isJPG = file.type === "image/jpeg";
      const isJPG2 = file.type === "image/jpg";
      const isPNG = file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 1;
      if (!isSVG&&!isJPG && !isJPG2 && !isPNG) {
        this.$message.warning("只支持svg或jpeg或jpg或png格式图片");
      }
      if (!isLt5M) {
        this.$message.warning("请上传1MB以内的图片!");
      }
      return (isSVG||isJPG || isJPG2 || isPNG) && isLt5M;
    },
    handleRemove(file, fileList) {
       this.httpRequestImg=false
      console.log(file);
      console.log(fileList);
      this.dialogImageUrl = "";
      this.fileList = [];
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    validateName(rule, value, callback) {
      console.log(value.length);

      if (value === "") {
        callback(new Error("名称不能为空"));
      } else if (value.length > 20) {
        callback(new Error("名称长度不能超过20个字符"));
      } else if (value.length <1) {
        callback(new Error("名称长度不能少于1个字符"));
      } else {
        var reg = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]");
        if (reg.test(value)) {
          callback(
            new Error("名称不合法,设备名称中不能包含特殊符号！")
          );
        } else {
          callback();
        }
      }
    },
    validateFireElevator(rule, value, callback) {
      if (value === "") {
        callback(new Error("消防电梯数不能为空"));
      } else if (value.length > 20) {
        callback(new Error("消防电梯数不能超过20个字符"));
      } else if (value.length <1) {
        callback(new Error("消防电梯数不能少于1个字符"));
      } else {
        var reg = new RegExp(/^(0|[1-9][0-9]*)$/);
        if (!reg.test(value)) {
          callback(new Error("消防电梯数不合法,请输入由正整数组成的数字！"));
        } else {
          callback();
        }
      }
    }
  },

};
</script>

<style lang="scss">
.drawerWrap {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 250px;
    }

    .el-transfer__buttons {
      width: 65px;
      text-align: center;

      .el-button {
        margin: 5px 0;
        width: 56px;
      }
    }
  }

  .el-switch {
    width: 100%;
  }

  .el-image {
    margin-right: 20px;
  }

  .el-form {
    margin-top: 20px;

    .el-form-item__label {
      line-height: 50px;
    }

    .el-form-item__content {
      line-height: 50px;
    }

    .el-select {
      width: 100%;
    }

    .el-input {
      width: 270px;

      .el-input__inner {
        height: 40px;
        line-height: 40px;
      }
    }
  }

  .drawerBody .el-form-item__label,
  .sp {
    color: #6e6e6e;
    text-align: right;
  }

  //多选框
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #2074e6;
    border-color: #2074e6;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #2074e6;
  }

  .el-button--primary {
    color: #fff;
    background-color: #2074e6;
    border-color: #2074e6;
  }

  .el-button--primary:focus,
  .el-button--primary:hover {
    background: #4074e6;
    border-color: #4074e6;
    color: #fff;
  }

  .el-form-item__content {
    .el-upload-list--picture-card {
      .el-upload-list__item {
        width: 120px;
        height: 120px;
      }
    }

    .el-upload--picture-card {
      width: 120px;
      height: 120px;
      line-height: 122px;
    }
  }
  .demo-httpRequestImg{
   //  /deep/ 
      .el-upload--picture-card{
         display: none;
      }
  } 
}
</style>
